import { render } from "./ImageGalleries.vue?vue&type=template&id=1de1a79f"
import script from "./ImageGalleries.vue?vue&type=script&lang=js"
export * from "./ImageGalleries.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__